export default "<p>redirect-terms-and-condition works!</p>\r\n";